import React from 'react';
import './walkthrough.css';
import CN_mascot_left from './assets/CN_mascot-pointing_left.png'
import CN_mascot_right from './assets/CN_mascot-pointing_right.png'
import CN_mascot_center from './assets/CN_Mascot.png'

export default function WalkthroughContent(props) {

    function imagePosition(position) {
        switch (position) {
            case "LEFT":
                return CN_mascot_left
            case "RIGHT":
                return CN_mascot_right
            default:
                return CN_mascot_center
        }
    }

    return (
        <div className={`siteTour__container img--${props.imagePosition}`}>
            <img
                src={imagePosition(props.imagePosition.toUpperCase())}
                alt="CN Mascot"
                className={`${props.mobile ? 'siteTour-mobile' : 'siteTour'}`}
            />
            <div className="siteTourContent">
                <p>{props.text}</p>
            </div>
        </div>
    );
}
